import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-allotment-cancellation',
  templateUrl: './allotment-cancellation.component.html',
  styleUrls: ['./allotment-cancellation.component.css']
})
export class AllotmentCancellationComponent implements OnInit {

  title = "Allotment Cancellation";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/allotment-cancellation/allotment-cancellation.component.ts